"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.enumerateArray = enumerateArray;
exports.getArrayIndex = getArrayIndex;
exports.walkMap = walkMap;
exports.walkMapKeys = walkMapKeys;
exports.getMapKey = getMapKey;
exports.getMapKeyPath = getMapKeyPath;
exports.hasMapKey = hasMapKey;
exports.isMapEmpty = isMapEmpty;
exports.topologicalList = topologicalList;

var _exceptions = require("./exceptions");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(enumerateArray),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(walkMap),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(walkMapKeys);

function isObject(v) {
  return v !== null && v !== void 0 && (typeof v === "undefined" ? "undefined" : _typeof(v)) === "object";
}

function enumerateArray(array) {
  var i, _i;

  return regeneratorRuntime.wrap(function enumerateArray$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(array !== undefined && array.size !== undefined && array.get !== undefined)) {
            _context.next = 10;
            break;
          }

          i = 0;

        case 2:
          if (!(i < array.size)) {
            _context.next = 8;
            break;
          }

          _context.next = 5;
          return [i, array.get(i)];

        case 5:
          i++;
          _context.next = 2;
          break;

        case 8:
          _context.next = 21;
          break;

        case 10:
          if (!Array.isArray(array)) {
            _context.next = 20;
            break;
          }

          _i = 0;

        case 12:
          if (!(_i < array.length)) {
            _context.next = 18;
            break;
          }

          _context.next = 15;
          return [_i, array[_i]];

        case 15:
          _i++;
          _context.next = 12;
          break;

        case 18:
          _context.next = 21;
          break;

        case 20:
          throw new _exceptions.NotAnArray("Data is invalid for array-like structure: " + array);

        case 21:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getArrayIndex(array, index) {
  if (array === undefined) {
    return undefined;
  } else if (array.get !== undefined) {
    return array.get(index);
  } else {
    return array[index];
  }
}

function walkMap(map) {
  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

  return regeneratorRuntime.wrap(function walkMap$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (isObject(map)) {
            _context2.next = 4;
            break;
          }

          throw new _exceptions.NotAMap("Data invalid for Map: " + map);

        case 4:
          if (!(map.keys !== undefined && map.get !== undefined)) {
            _context2.next = 8;
            break;
          }

          return _context2.delegateYield(map, "t0", 6);

        case 6:
          _context2.next = 34;
          break;

        case 8:
          // Handle regular objects
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context2.prev = 11;
          _iterator = Object.keys(map)[Symbol.iterator]();

        case 13:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context2.next = 20;
            break;
          }

          key = _step.value;
          _context2.next = 17;
          return [key, map[key]];

        case 17:
          _iteratorNormalCompletion = true;
          _context2.next = 13;
          break;

        case 20:
          _context2.next = 26;
          break;

        case 22:
          _context2.prev = 22;
          _context2.t1 = _context2["catch"](11);
          _didIteratorError = true;
          _iteratorError = _context2.t1;

        case 26:
          _context2.prev = 26;
          _context2.prev = 27;

          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }

        case 29:
          _context2.prev = 29;

          if (!_didIteratorError) {
            _context2.next = 32;
            break;
          }

          throw _iteratorError;

        case 32:
          return _context2.finish(29);

        case 33:
          return _context2.finish(26);

        case 34:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this, [[11, 22, 26, 34], [27,, 29, 33]]);
}

function walkMapKeys(map) {
  return regeneratorRuntime.wrap(function walkMapKeys$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (isObject(map)) {
            _context3.next = 4;
            break;
          }

          throw new _exceptions.NotAMap("Data invalid for Map: " + map);

        case 4:
          if (!(map.keys !== undefined)) {
            _context3.next = 8;
            break;
          }

          return _context3.delegateYield(map.keys(), "t0", 6);

        case 6:
          _context3.next = 9;
          break;

        case 8:
          return _context3.delegateYield(Object.keys(map), "t1", 9);

        case 9:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function getMapKey(map, key) {
  if (!map) {
    return undefined;
  } else if (map.get !== undefined) {
    return map.get(key);
  } else if (map.hasOwnProperty(key)) {
    return map[key];
  } else {
    return undefined;
  }
}

function getMapKeyPath(map, keyPath) {
  if (!isObject(map)) {
    return undefined;
  } else if (map.getIn !== undefined) {
    return map.getIn(keyPath);
  } else {
    var current = map;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = enumerateArray(keyPath)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var key = _step2.value;

        if (current === undefined) {
          break;
        }
        current = getMapKey(current, key);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return current;
  }
}

function hasMapKey(map, key) {
  if (!isObject(map)) {
    return false;
  } else if (map.has !== undefined) {
    return map.has(key);
  } else {
    return map.hasOwnProperty(key) && map[key] !== undefined;
  }
}

function isMapEmpty(map) {
  if (!isObject(map)) {
    if (map !== undefined && map !== null) {
      console.error('returning empty for a map that was not undefined or null: ', map);
    }
    return true;
  } else if (map.isEmpty !== undefined) {
    return map.isEmpty();
  } else {
    return Object.keys(map).length === 0;
  }
}

/*
 * Takes an array of objects and functions for retrieving the key of each objects and the dependency keys for each
 * object.
 *
 * Returns null if the dependencies are cyclical
 *
 * Returns a 2D array of keys ordered by topological sort order.
 * Keys at index 0 are orphans/independent, keys at index 1 are the initial dependencies, keys at i > 1 are dependencies
 * of keys at i <= 1.
 */

function topologicalList(objects, getKey, getDependencyKeys) {
  var sortedList = [];
  var objectsByKey = {};
  var dependenciesByKey = {};
  var dependentsByKey = {};
  var object = void 0,
      key = void 0,
      dependencyKeys = void 0;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = objects[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      object = _step3.value;

      key = getKey(object);
      objectsByKey[key] = object;
      dependenciesByKey[key] = getDependencyKeys(object);
      dependentsByKey[key] = [];
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  var dependencyKey = void 0,
      keys = Object.keys(objectsByKey);
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = keys[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      key = _step4.value;

      dependencyKeys = dependenciesByKey[key];
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = dependencyKeys[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          dependencyKey = _step10.value;

          dependentsByKey[dependencyKey].push(key);
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  var independentKeys = keys.filter(function (key) {
    return dependenciesByKey[key].length === 0 && dependentsByKey[key].length === 0;
  });
  var initialKeys = keys.filter(function (key) {
    return dependenciesByKey[key].length === 0 && dependentsByKey[key].length > 0;
  });
  var dependentKeys = keys.filter(function (key) {
    return dependenciesByKey[key].length > 0;
  });

  var cycle = false;
  var independentDepth = 0;
  var initialDepth = 1;

  sortedList[independentDepth] = independentKeys;
  sortedList[initialDepth] = initialKeys;

  var dependentKeyDepths = {};

  var markedKeys = {};
  var visit = function visit(key, depth) {
    if (cycle === true || markedKeys[key] === true) {
      cycle = true;
    } else {
      var existingDepth = dependentKeyDepths[key];

      if (existingDepth === undefined || depth > existingDepth) {
        dependentKeyDepths[key] = depth;
        var dependentKey = void 0;
        markedKeys[key] = true;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = dependentsByKey[key][Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            dependentKey = _step5.value;

            visit(dependentKey, depth + 1);
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        markedKeys[key] = false;
      }
    }
  };

  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = initialKeys[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      key = _step6.value;

      if (cycle === false) {
        var dependentKey = void 0;
        markedKeys[key] = true;
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = dependentsByKey[key][Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            dependentKey = _step11.value;

            visit(dependentKey, initialDepth + 1);
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        markedKeys[key] = false;
      }
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  if (cycle === false) {
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = dependentKeys[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        key = _step7.value;

        if (dependentKeyDepths[key] === undefined) {
          cycle = true;
        }
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }
  }

  if (cycle === false) {
    var maxDepth = 0;
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = dependentKeys[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        key = _step8.value;

        if (dependentKeyDepths[key] !== undefined && dependentKeyDepths[key] > maxDepth) {
          maxDepth = dependentKeyDepths[key];
        }
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }

    var depth = void 0;
    for (depth = initialDepth + 1; depth <= maxDepth; depth++) {
      sortedList[depth] = [];
    }

    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = dependentKeys[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        key = _step9.value;

        if (dependentKeyDepths[key] !== undefined) {
          sortedList[dependentKeyDepths[key]].push(key);
        }
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }
  }

  return cycle ? null : sortedList;
}